<template>
  <div class="archived container">
    <h1>Archived Projects</h1>
    <button @click="goHome">Go home</button>
    <transition name="fade" mode="in-out">
      <Boards :boards="boards" :sharedBoards="sharedBoards" />
    </transition>
  </div>
</template>

<script>
import db from "@/fb/init";
import Boards from "@/components/Boards";

export default {
  name: "archived",
  props: ["user", "currentUser"],
  data() {
    return {
      userId: null,
      boards: [],
      sharedBoards: []
    };
  },
  components: { Boards },
  beforeMount() {
    this.userId = sessionStorage.getItem("userId");
  },
  mounted() {
    db.collection("boards")
      .where("userId", "==", this.userId)
      .where("archived", "==", true)
      .orderBy("name")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            this.boards.push({ ...change.doc.data() });
          }
          if (change.type === "modified") {
            this.boards.forEach(b => {
              if (b.board_id === change.doc.id) {
                b = change.doc.data();
              }
            });
          }
          if (change.type === "removed") {
            this.boards = this.boards.filter(b => b.board_id !== change.doc.id);
          }
        });
      });
  },
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>
